<template>
  <div>
    <el-row :span="24" :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="12">
        <el-date-picker
          v-model="date"
          :clearable='false'
          format="d MMM yy"
          value-format="timestamp"
          type="date"
          placeholder="As At">
        </el-date-picker>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <div class="data-hide">
      <el-table
        :data="tableData"
        border
        size="mini"
        style="width: 100%">
        <el-table-column
          label="DB Code"
          width="100">
        </el-table-column>
        <el-table-column
          label="Acc. No."
          width="100">
        </el-table-column>
        <el-table-column
          label="Tax Accounts">
        </el-table-column>
        <el-table-column
          label="Tax Code"
          header-align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="Rate %"
          header-align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="Report"
          header-align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="Ending Balances"
          header-align="center"
          width="300">
        </el-table-column>
        <el-table-column
          label="Set As"
          header-align="center"
          width="100">
        </el-table-column>
      </el-table>
    </div>

    <!-- withHoldingTaxExpandedEndingBalances -->
    <el-table
      :data="withHoldingTaxExpandedEndingBalances"
      :show-header="false"
      size="mini"
      :row-class-name="tableRowClassName"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxaccounts"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          Amount: {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

    <!-- withHoldingTaxExpandedSubAccountsEndingBalances -->
    <el-table
      :data="withHoldingTaxExpandedSubAccountsEndingBalances"
      :show-header="false"
      size="mini"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountname"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          <span @click="openModalDetailed(scope.row)" style="color: #409EFF; cursor: pointer;">
            {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
          </span>
          </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

    <!-- :currencyList="currencyList" -->
    <generall-ledger-detailed-modal
      :startDate="createCompanyDate"
      :endDate="date"
      ref="generallLedgerDetailedModal"
      @loadList="loadList"
      @closeModal="closeModal"/>
  </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment');
  import GenerallLedgerDetailedModal from '@/components/settings/settingsGlAccounts2/GenerallLedgerDetailedModal'

  export default {
    components: {
      GenerallLedgerDetailedModal
    },
    computed: {
      companyLayout () {
        return this.$store.getters.getCompanyLayout
      },
      createCompanyDate () {
        return this.companyLayout && this.companyLayout.createCompanyDate ? moment(this.companyLayout.createCompanyDate, 'DD/MM/YYYY').format('x') : null
      },
    },
    data() {
      return {
        date: moment().format("x"),
        tableData: [],

        inputTax: [],
        inputTaxSubAccounts: [],
        outputTax: [],
        outputTaxSubAccounts: [],
        creditableVatWithheld: [],
        creditableVatWithheldSubAccounts: [],
        getSalesTaxPayableBalance: [],
        getSalesTaxOwing: [],

        withHoldingTaxExpandedEndingBalances: [],
        withHoldingTaxExpandedSubAccountsEndingBalances: [],
      }
    },
    methods: {
      loadList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/account/taxAccountsResultWh?companyId=${this.$route.query.companyId}&endDate=${moment(this.date, 'x').format('MM-DD-YYYY')}`)
          .then(response => {
            // this.outputTax = response.data.data.outputTax
            // this.outputTaxSubAccounts = response.data.data.outputTaxSubAccounts
            // this.inputTax = response.data.data.inputTax
            // this.inputTaxSubAccounts = response.data.data.inputTaxSubAccounts
            // this.creditableVatWithheld = response.data.data.creditableVatWithheld
            // this.creditableVatWithheldSubAccounts = response.data.data.creditableVatWithheldSubAccounts
            // this.getSalesTaxPayableBalance = response.data.data.getSalesTaxPayableBalance
            // this.getSalesTaxOwing = response.data.data.getSalesTaxOwing
            this.withHoldingTaxExpandedEndingBalances = response.data.data.withHoldingTaxExpandedEndingBalances
            this.withHoldingTaxExpandedSubAccountsEndingBalances = response.data.data.withHoldingTaxExpandedSubAccountsEndingBalances
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      tableRowClassName({row, rowIndex}) {
        return 'bg-row';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      closeModal() {},
      openModalDetailed(row) {
        const params = {
          data: {
            id: row.accountid,
            name: row.accountname,
            code: row.dbcode,
            DRCRCode: row.setas,
            accountCurrencyId: null
          }
        }
        this.$refs.generallLedgerDetailedModal.openModal(params);
      }
    },
    watch:{
      'date': function (val) {
        this.loadList()
      }
    },
  }
</script>

<style lang="scss" scoped>
.data-hide {
  /deep/.el-table__body-wrapper {
    display: none;
  }
}
/deep/.el-table .bg-row {
  background: #f2f4f7;
}
</style>